import { gql } from "graphql-tag";

export const SAVE_SHIPPING_AGENT = gql`
  mutation SaveAgent($input: AgentRegReqInput!) {
    saveAgent(input: $input) {
        code
        data {
            active
            uuid
        }
        extras
        fieldsErrors
        message
        status
    }
}`;



export const AGENT_REGISTRATION_PROGRESS = gql`
  query AgentRegistrationProgress($agentUuid: UUID!) {
    agentRegistrationProgress(agentUuid: $agentUuid) {
        code
        extras
        fieldsErrors
        message
        status
        data {
            active
            allSectionsComplete
            applicationSubmitted
            applicationSubmittedAt
            declarationComplete
            declarationCompletedAt
            documentCompletedAt
            requiredDocumentComplete
            tasacDetailsComplete
            tasacDetailsCompletedAt
            uuid
            agentRegistration {
                active
                address
                attachableDiscriminator
                bucketName
                companyName
                declarantName
                declarantTitle
                declarationAccepted
                declarationAcceptedAt
                discriminator
                email
                name
                otherAttachmentName
                phoneNumber
                registrationDate
                registrationNumber
                registrationStatus
                registrationType
                tasacExpireDate
                tasacIssuingOffice
                tasacLicenseCategory
                tasacRegDate
                tasacRegistrationNumber
                tin
                type
                uuid
                agentType {
                    active
                    code
                    name
                    uuid
                }
                attachments {
                    active
                    id
                    minioObjectName
                    otherAttachmentName
                    uuid
                    attachable {
                        attachableDiscriminator
                        bucketName
                        id
                        otherAttachmentName
                        registrationType
                        uuid
                    }
                    attachmentType {
                        active
                        fileSize
                        fileType
                        id
                        kind
                        name
                        uuid
                    }
                }
            }
        }
    }
}`;

export const SUBMIT_AGENT_APPLICATION = gql`
  mutation SubmitAgentApplication($input: AgentApplicationReqInput!) {
    submitAgentApplication(input: $input) {
        code
        extras
        fieldsErrors
        message
        status
        data {
          uuid
          active
        }
    }
}`;

export const AGENT_REGISTATION_SUMMARY = gql`
  query AgentRegistrationSummary($agentUuid: UUID!) {
    agentRegistrationSummary(agentUuid: $agentUuid) {
        data {
            address
            agentType
            agentUuid
            allApplicationStepComplete
            email
            name
            phoneNumber
            registrationNumber
            status
            tasacRegistrationNumber
            attachments {
                active
                id
                minioObjectName
                otherAttachmentName
                uuid
                attachable {
                    attachableDiscriminator
                    bucketName
                    id
                    otherAttachmentName
                    registrationType
                    uuid
                }
                attachmentType {
                    active
                    fileSize
                    fileType
                    id
                    kind
                    name
                    uuid
                }
            }
        }
        code
        extras
        fieldsErrors
        message
        status
    }
}
`;

export const GET_SHIPPING_AGENT_TYPES = gql`
  query GetAgentTypes {
    getAgentTypes(fetchAll: true) {
        code
        extras
        fieldsErrors
        message
        status
        data {
            active
            code
            name
            uuid
        }
    }
}`;